import Vue from "vue";
import Vuex from "vuex";
import Service from "../../../service/api.js";
import router from "../../../router/index.js";
import store from "@/store/store";

const ServerModule = {
    namespaced: true,
    state: {
        item : []
    },

    mutations: {
        course(state, obj) {
            state.item = obj;
        }
    },

    actions: {
        config({commit}, data) {
            Service.course('exp', data, {})
                .then((response) => {
                    store.commit("courses/course", response.data.data)

                }).catch((err) => {
            });
        },
        create({commit}, data) {
            Service.course('post', data, {})
                .then((response) => {

                }).catch((err) => {
            });
        },
        update({commit}, data) {
            Service.course('put', data, {})
                .then((response) => {

                }).catch((err) => {
            });
        },
    },

    getters: {
        course(state, obj) {
            return state.item;
        },
    },
};

export default ServerModule;
